<template>
  <div class="chaffCityStatistics-box">
    <div class="top-content">
      <div
        class="signer-center"
        v-for="(item, index) in list"
        :key="index"
        :style="`background: ${item.bColor};`"
        @click="handleClick(item.path, item.query)"
      >
        <p class="title-weight">{{ formInline[item.key] || 0 }}</p>
        <p class="title-name" :style='`color: ${item.vColor};`'>{{ item.title }}</p>
      </div>
    </div>
    <div class="body-content">
      <div class="d-flex ptb-15">
        <div class="product-box">
          <p class="content-title">项目名称:</p>
          <el-input
            v-model="selectObj.projectName"
            placeholder="请输入内容"
            clearable
          ></el-input>
        </div>
        <div class="product-box">
          <p class="content-title">是否实名制:</p>
          <el-select
            v-model="selectObj.regState"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in regState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="product-box">
          <p class="content-title">项目状态:</p>
          <el-select
            v-model="selectObj.prjStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in prjStatus"
              :key="i"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="product-box">
          <el-button size="small" type="primary" @click="handleQuery"
            >搜索</el-button
          >
          <el-button size="small" @click="onClickReset">重置</el-button>
        </div>
      </div>
      <Table
        border
        size="small"
        :loading="loading"
        :columns="allColumns"
        :data="allData"
        highlight-row
      >
      </Table>
      <div class="t-page">
        <Page
          :total="totalCount"
          :page-size="pageSize"
          :current="page"
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
          show-elevator
          show-sizer
          show-total
          transfer
        >
        </Page>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import tableMixin from "@/components/tableMixin";
import { getDistrictData } from "@/api/platform";
export default {
  mixins: [tableMixin],
  data() {
    return {
      list: [
        {
          title: "在建项目数",
          unit: "",
          path: "sprojectList",
          key: "totalNumber",
          bColor: "rgba(51, 153, 255, 0.08)",
          vColor: "rgba(51, 153, 255, 1)",
          query: { prjStatus: "003" }
        },
        {
          title: "实名制项目",
          unit: "",
          path: "sprojectList",
          key: "projectNumber",
          bColor: "rgba(159, 99, 251, 0.08)",
          vColor: "rgba(159, 99, 251, 1)",
          query: { regState: 1 }
        },
        {
          title: "在建实名制项目",
          unit: "万人次",
          path: "sprojectList",
          key: "buildProjectNumber",
          bColor: "rgba(0, 204, 102, 0.08)",
          vColor: "rgba(0, 204, 102, 1)",
          query: { regState: 1, prjStatus: "003" }
        },
        {
          title: "参建单位",
          unit: "家",
          path: "sunitList",
          key: "companyNumber",
          bColor: "rgba(101, 113, 128, 0.08)",
          vColor: "rgba(70, 76, 91, 1)"
        },
        {
          title: "在册管理人员",
          unit: "人",
          path: "spersonnelList",
          key: "registeredManagerNumber",
          bColor: "rgba(61, 93, 255, 0.08)",
          vColor: "rgba(61, 93, 255, 1)",
          query: { workRole: 10, workerStatus: 2 }
        },
        {
          title: "在册建筑工人",
          unit: "人",
          path: "spersonnelList",
          key: "registeredWorkerNumber",
          bColor: "rgba(17, 223, 189, 0.08)",
          vColor: "rgba(17, 223, 189, 1)",
          query: { workRole: 20, workerStatus: 2 }
        },
        {
          title: "在岗管理人员",
          unit: "人",
          path: "spersonnelList",
          key: "postManagerNumber",
          bColor: "rgba(101, 113, 128, 0.08)",
          vColor: "rgba(70, 76, 91, 1)",
          query: { workRole: 10, workerStatus: 1 }
        },
        {
          title: "在岗建筑工人",
          unit: "人",
          path: "spersonnelList",
          key: "postWorkerNumber",
          bColor: "rgba(101, 113, 128, 0.08)",
          vColor: "rgba(70, 76, 91, 1)",
          query: { workRole: 20, workerStatus: 1 }
        },
        {
          title: "考勤次数",
          unit: "万",
          path: "schecking-inList",
          key: "attendanceNumber",
          bColor: "rgba(101, 113, 128, 0.08)",
          vColor: "rgba(70, 76, 91, 1)"
        },
        {
          title: "教育培训",
          unit: "万人次",
          path: "seducation",
          key: "trainingNumber",
          bColor: "rgba(101, 113, 128, 0.08)",
          vColor: "rgba(70, 76, 91, 1)"
        }
      ],
      selectObj: {},
      formInline: [],
      loading: false,
      // 表头数据
      allColumns: [
        {
          title: "序号",
          type: "index"
          // minWidth: 80,
        },
        {
          title: "项目名称",
          key: "projectName"
        },
        {
          title: "是否实名制",
          key: "regState"
        },
        {
          title: "项目状态",
          key: "prjStatus"
        },
        {
          title: "参建单位",
          key: "winUnit"
        },
        {
          title: "在岗管理人员",
          key: "onlineManagersNum"
        },
        {
          title: "在册管理人员",
          key: "onManagersNum"
        },
        {
          title: "在岗建筑工人",
          key: "onlinelabourNum"
        },
        {
          title: "在册建筑工人",
          key: "onlabourNum"
        },
        {
          title: "考勤次数",
          key: "attendanceNum"
        },
        {
          title: "教育培训",
          key: "educationNum"
        }
      ],
      // 表格内容
      allData: [],
      currentPage: 1,
      regState: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      prjStatus: [
        {
          label: "筹备",
          value: "001"
        },
        {
          label: "立项",
          value: "002"
        },
        {
          label: "在建",
          value: "003"
        },
        {
          label: "完工",
          value: "004"
        },
        {
          label: "停工",
          value: "005"
        }
      ],
      curAreaCode: localStorage.getItem("tenantAreaCode"),
      source: null // 取消请求使用
    };
  },
  created() {
    this.queryProvinceOverview();
  },
  mounted() {
    console.log(666)
  },
  methods: {
    // 顶部点击事件
    handleClick(name, query = {}) {
      query.areaCode = this.curAreaCode;
      this.$router.push({
        name: name,
        query
      });
    },

    onClickReset() {
      this.selectObj = {};
      this.page=1;
      this.pageSize=10;
      this.getTableData();
      console.log(this.selectObj, "onClickReset");
    },

    // 表格数据
    getTableData() {
      console.log('request start')
      let params = {
        projectName: this.selectObj.projectName,
        regState: this.selectObj.regState,
        prjStatus: this.selectObj.prjStatus,
        current: this.page,
        size: this.pageSize,
        areaCode: parseInt(localStorage.getItem('tenantAreaCode')),//520322
      };
      console.log(params, "params");
      this.loading = true;
      getDistrictData(params).then(res => {
        console.log(`res:`,res)
        if (res.data&&res.data.data&&res.data.data.records) {
          this.allData = res.data.data.records;
          this.totalCount = res.data.data.total;
          this.loading = false;
          console.log('request end,123')
        }else{
          this.allData=[];
          this.loading = false;
          console.log('request end,456')
        }
      });
    },

    // 顶部接口
    queryProvinceOverview() {
      this.formInline = {};
      let today = this.$moment(new Date().getTime()).format("YYYY-MM-DD");
      let params = {
          today,
          areaCode: this.curAreaCode
      }
      this.axios({
        cancelToken: new axios.CancelToken(c => {
          this.source = c;
        }),
        method: "post",
        url: "/summary/sx/queryProvinceOverview",
        data: params
      }).then(response => {
        // console.log('顶部接口返回数据',response)
        if (response.data) {
          this.formInline = response.data || {};
          // console.log(this.formInline.companyNumber,'参建单位')
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.chaffCityStatistics-box {
  // background: red;
  .top-content {
    width: 100%;
    background: #f5f7f9;
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .signer-center {
      width: 19%;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // background-color: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      .title-weight {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        cursor: pointer;
      }
      .title-name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #657180;
        cursor: pointer;
      }
    }
  }

  .body-content {
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
    .ptb-15 {
      padding: 15px 0;
    }
    .pagination-box {
      padding: 6px 0;
      background: #fff;
    }
    .d-flex {
      display: flex;
      align-items: center;
      // justify-content: center;
      .w-280 {
        width: 280px;
      }
      .product-box {
        width: 25%;
        margin-right: 15px;
        display: flex;
        align-items: center;
        .content-title {
          width: 100px;
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  // /deep/ .el-input {
  //   width: 70%;
  // }
  /deep/ .el-input__inner {
    // width: 70%;
    height: 34px;
  }
}
</style>
